export default "__VITE_ASSET__D8l08aBH__"